import historyStore from '@/stores/history';

// 更新历史消息中某条dialogue外层数据，非data中的数据
export const updateHistoryDialogueData = (dialogue, messageId) => {
  messageId && historyStore.UPDATE_DIALOGUE({
    obj: dialogue,
    messageId,
  });
};

// 更新历史消息中某条dialogue外层数据，非data中的数据
export const updateHistoryDialogueOuterData = (dialogue, messageId) => {
  messageId && historyStore.UPDATE_DIALOGUE_OUTER_DATA({
    obj: dialogue,
    messageId,
  });
};
